import { render } from "./StudentsProjects.vue?vue&type=template&id=da780270&scoped=true"
import script from "./StudentsProjects.vue?vue&type=script&lang=js"
export * from "./StudentsProjects.vue?vue&type=script&lang=js"

import "./StudentsProjects.vue?vue&type=style&index=0&id=da780270&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da780270"

export default script